<div class="input-group" (click)="openCalendar()">
    <input
        #dateInput
        class="form-control pe-0"
        type="date"
        [value]="value()"
        [disabled]="disabled()"
        [readOnly]="readonly()"
        [required]="required()"
        [attr.min]="minDate() || undefined"
        [attr.max]="maxDate() || undefined"
        [attr.aria-label]="ariaLabel()"
        [attr.aria-invalid]="isInvalid()"
        [class.is-valid]="isValid()"
        [class.is-invalid]="isInvalid()"
        (input)="onInput($event)"
        (blur)="touched.set(true)"
    />
    <span class="input-group-text"><fa-icon [icon]="faCalendar"></fa-icon></span>
</div>
@if (hasErrorMessages()) {
    <div class="invalid-feedback d-block">
        @for (error of errors(); track error.kind) {
            <div>{{ error.message ?? error.kind }}</div>
        }
    </div>
}
